import {computed, signal} from "@preact/signals-react";
import {FORMAT_DATE_BACK, formatDate, getPreviousDate} from "@ui-seeker/utils";

//Filters
export const dateRange = signal([ getPreviousDate({ days: 1 }), getPreviousDate({ days: 1 }) ])
export const customerID = signal(null)
export const country = signal([])
export const retailer = signal([])
export const brand = signal([])
export const sku = signal(null)

export const isLoadingNewProducts = signal(false)
export const disabledSubmitNewProducts = signal(false)

//Table
export const newProductsTableData = signal([])
export const newProductsRowEditClicked = signal(null)
export const newProductsRowCreateSkuClicked = signal(null)
export const newProductsBrandForm = signal(null)
export const newProductsSkuForm = signal(null)
export const newProductsLoadingRow = signal([])
export const newProductsMultipleRowsEdit=signal([])
export const newProductsMultipleRowsSkip=signal([])
export const newProductsMultipleRowsSend=signal([])

//Mapping Form
export const skuForm = signal(null)
export const brandForm = signal(null)
export const customerIDForm = signal(null)

export const unmatchedNewProductsFilters = computed(() => ({
    startDate: formatDate(dateRange.value[0], { format: FORMAT_DATE_BACK }),
    endDate: formatDate(dateRange.value[1], { format: FORMAT_DATE_BACK }),
    country: country.value,
    retailer: retailer.value,
    brand: brand.value,
    customerID: customerID.value
}))

export const resetNewProductsFilers = () => {
    dateRange.value = [ getPreviousDate({ days: 1 }), getPreviousDate({ days: 1 }) ]
    customerID.value = null
    country.value = []
    retailer.value = []
    brand.value = []
}